/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationUtilizationDefinition {
    getFixupPrototypeFunction() { return ScheduleRecommendationUtilizationDefinition.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationUtilizationDefinition>): ScheduleRecommendationUtilizationDefinition {
        let obj = Object.assign(new ScheduleRecommendationUtilizationDefinition(), model);
        ScheduleRecommendationUtilizationDefinition.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationUtilizationDefinition>): ScheduleRecommendationUtilizationDefinition {
        if (!model) return null;
        return ScheduleRecommendationUtilizationDefinition.newInstance(<ScheduleRecommendationUtilizationDefinition> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationUtilizationDefinition) {
        if (!obj) return;

        models.ScheduleRecommendationUtilizationDefinition.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationUtilizationDefinition): boolean {
        Object.setPrototypeOf(obj, ScheduleRecommendationUtilizationDefinition.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.minimum_value === undefined) {
            this.minimum_value = 0;
        }
        if (this.maximum_value === undefined) {
            this.maximum_value = 0;
        }
        if (this.low_utilization === undefined) {
            this.low_utilization = 0;
        }
        if (this.high_utilization === undefined) {
            this.high_utilization = 0;
        }
    }

    /**
     * Name of the Metric
     */
    metric_name: string;

    /**
     * Unit of the metric
     */
    metric_unit: string;

    /**
     * Minimum Metric Value
     */
    minimum_value: number;

    /**
     * Maximum Metric Value
     */
    maximum_value: number;

    /**
     * Minimum Utilization Value
     */
    low_utilization: number;

    /**
     * Maximum Utilization Value
     */
    high_utilization: number;

}
